// extracted by mini-css-extract-plugin
export default {"basicInput":"BaseSearch_basicInput__yr7Uu"};